module.exports = __webpack_public_path__ + "static/media/the-architect.f170a615.png";